import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Log } from 'ng2-logger';

const log = Log.create('DeleteModal');

@Component({
  moduleId: module.id,
  selector: 'delete-modal',
  templateUrl: 'delete.component.html',
  styleUrls: ['delete.less']
})
export class BatchDeleteComponent {

  @Input()
  title: string = 'Delete';

  @Input()
  description: string = 'Deleting this item will remove all of its information from our database. This action cannot be undone.';

  @Input()
  show: boolean = false;

  @Output()
  confirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

  userconfirm: string = '';

  mismatch: boolean = false;

  onMatchConfirmInput() {
    if (this.userconfirm === 'DELETE') {
      this.userconfirm = '';
      this.confirmed.emit(true);
      this.mismatch = false;
    } else {
      this.mismatch = true;
    }
    log.data('onMatchConfirmInput', this.userconfirm, this.mismatch);
  }

  onClose() {
    this.confirmed.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/_component/delete/delete.component.ts